import { success } from "@secretaa/http-contract";
import { z } from "zod";
import { Scope,Profile } from "./ai-model-control.ts";
import { AssistantWorkMessage } from "./work-os/conversation.ts";
export const Command=z.object({scope:Scope,profile:Profile,expectedRunRevision:z.number().int().positive(),draft:AssistantWorkMessage.shape.draft,text:AssistantWorkMessage.shape.text,sourceMessageIds:AssistantWorkMessage.shape.sourceMessageIds}).strict();
export type Command=z.infer<typeof Command>;
export const Result=z.object({scope:Scope,profile:Profile,runRevision:z.number().int().positive(),state:z.literal("SUCCEEDED"),message:AssistantWorkMessage}).strict().refine(r=>r.message.aiRunId===r.scope.aiRunId,"REPLY_RUN_MISMATCH");
export type Result=z.infer<typeof Result>;
export const Response=success(Result);
export const PATH="/api/internal/v1/ai-preparation-replies";
export const CONTRACT_VERSION="1.1.0";
